
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stories/global-outlook",
      function () {
        return require("private-next-pages/stories/global-outlook.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stories/global-outlook"])
      });
    }
  